import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import { logged_user_routes } from "./apps/UserLogged/router";
import { auth_routes } from "./apps/Auth/router";
import Permission from "./apps/Permission/meta";
import Teacher from "./apps/Teacher/meta";
import Student from "./apps/Student/meta";
import Evaluation from "./apps/Evaluation/meta";
import Report from "./apps/Report/meta";

const routes = [
  ...logged_user_routes,
  ...auth_routes,
  ...Permission.routes,
  ...Teacher.routes,
  ...Student.routes,
  ...Evaluation.routes,
  ...Report.routes
];

export const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
